export default {
  /**
   * 店舗条件の標準フォーマット
   */
  get() {
    return {
      base: {
        /**
         * @see store.js
         */
        key: new Date().getTime().toString(),
        /**
         * 店舗グループ
         */
        storeGroup: undefined,
        /**
         * 店舗コード一覧
         */
        stores: [],
        /**
         * 入力エラー
         */
        errors: [],
      },
      compare: {
        /**
         * @see store.js
         */
        key: new Date().getTime().toString(),
        /**
         * 店舗グループ
         */
        storeGroup: undefined,
        /**
         * 店舗コード一覧
         */
        stores: [],
        /**
         * 入力エラー
         */
        errors: [],
      },
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(store) {
    return {
      base: {
        storeGroup: store.base.storeGroup,
        stores: store.base.stores,
      },
      compare: {
        storeGroup: store.compare.storeGroup,
        stores: store.compare.stores,
      },
    }
  },
  /**
   * applyToに対してitemを適用する
   */
  applyPayload(applyTo, store) {
    applyTo.base.key = new Date().getTime().toString()
    applyTo.compare.key = new Date().getTime().toString()

    // 対象/比較パターンに対して画面遷移することはないので、適用処理は必ず
    // このモデル形式をこのモデル形式に当てはめるだけ。
    applyTo.base.storeGroup = store.base.storeGroup
    applyTo.base.stores = store.base.stores
    applyTo.compare.storeGroup = store.compare.storeGroup
    applyTo.compare.stores = store.compare.stores
  },
}
